import { render, staticRenderFns } from "./text-area-control.vue?vue&type=template&id=59a33546&scoped=true"
import script from "./text-area-control.vue?vue&type=script&lang=js"
export * from "./text-area-control.vue?vue&type=script&lang=js"
import style0 from "./text-area-control.vue?vue&type=style&index=0&id=59a33546&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a33546",
  null
  
)

export default component.exports